import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';

import { Modal, ModalHeader, ModalBody, Button, ButtonToolbar } from 'reactstrap';
import EditProgramUserForm from './EditProgramUserForm'

const EditProgramUserModal = ({organization, program, userid, isOpen, setOpen, toggle, theme, rtl, setTrigger}) => {
    return (
        <Modal 
            className={`modal-program manager-program-modal manager-program-modal--wide modal-lg ${theme.className} ${rtl.direction}-support`}
            isOpen={isOpen}
            toggle={toggle}
        >
            <ModalHeader tag="div" className="manager-program-modal__header">
                <div className="manager-program-modal__header-row">
                    <div className="manager-program-modal__header-copy">
                        <h3 className="manager-program-modal__title">Edit User</h3>
                        <p className="manager-program-modal__subtitle">
                            Update program access and account details for this user.
                        </p>
                    </div>
                    <ButtonToolbar className="manager-program-modal__actions">
                        <Button outline color="primary" onClick={toggle}>Close</Button>
                    </ButtonToolbar>
                </div>
            </ModalHeader>
            <ModalBody className="manager-program-modal__body">
                    {organization?.id && program?.id && <EditProgramUserForm
                        organization={organization}
                        program={program}
                        userid={userid}
                        toggle={toggle}
                        setTrigger={setTrigger}
                    />}
            </ModalBody>
           
        </Modal>
    )
}
EditProgramUserModal.propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired
};
  
export default connect((state) => ({
    theme: state.theme,
    rtl: state.rtl
}))(EditProgramUserModal);
